import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button
              onClick={() => scrollToSection('hero')}
              className="flex items-center hover:opacity-80 transition-opacity relative"
            >
              {/* Logo pour fond FONCÉ (hero) - vert sur noir */}
              <img
                src="/logo-dark-bg.png"
                alt="Aventix"
                className={`h-12 w-auto transition-opacity duration-300 ${!isScrolled ? 'opacity-100' : 'opacity-0 absolute'}`}
                style={{ maxWidth: '200px' }}
              />
              {/* Logo pour fond CLAIR (scrollé) - gris */}
              <img
                src="/logo-light-bg.png"
                alt="Aventix"
                className={`h-12 w-auto transition-opacity duration-300 ${isScrolled ? 'opacity-100' : 'opacity-0 absolute'}`}
                style={{ maxWidth: '200px' }}
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-slate-700 hover:text-blue-600' 
                  : 'text-white hover:text-blue-300'
              }`}
            >
              À propos
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-slate-700 hover:text-blue-600' 
                  : 'text-white hover:text-blue-300'
              }`}
            >
              Services
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Contact
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`transition-colors ${
                isScrolled 
                  ? 'text-slate-700 hover:text-blue-600' 
                  : 'text-white hover:text-blue-300'
              }`}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 bg-white border-t border-slate-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-slate-700 hover:text-blue-600 transition-colors font-medium text-left px-4"
              >
                À propos
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-slate-700 hover:text-blue-600 transition-colors font-medium text-left px-4"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-blue-600 hover:text-blue-700 transition-colors font-medium text-left px-4"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
